import { getCurrentGreetingMessage } from "../utils/greetingMessage";

export const getNavbarHeading = (heading, dataText = "") => {
  const navbarHeadings = () => {
    return (
      <>
        <div
          className="navbar-greeting"
          style={{
            fontFamily: "inherit",
            fontWeight: 500,
            lineHeight: "20px",
            letterSpacing: "-0.01em",
            textAlign: "left",
            color: "#6E7485",
          }}
        >
          {getCurrentGreetingMessage()}
        </div>
        <div
          className="navbar-heading-title"
          style={{
            fontFamily: "inherit",
            fontWeight: 600,
            lineHeight: "26px",
            textAlign: "left",
            color: "#1D2026",
          }}
        >
          {heading === "my-classrooms" ? "My Classrooms" : heading}
        </div>
      </>
    );
  };

  const myClassroomDashboard = () => {
    return (
      <>
        <div
          className="navbar-greeting"
          style={{
            fontFamily: "inherit",
            fontWeight: 500,
            lineHeight: "20px",
            letterSpacing: "-0.01em",
            textAlign: "left",
            color: "#6E7485",
          }}
        >
          {getCurrentGreetingMessage()}
        </div>
        <div
          className="navbar-heading-title"
          style={{
            fontFamily: "inherit",
            fontWeight: 600,
            lineHeight: "26px",
            textAlign: "left",
            color: "#1D2026",
          }}
        >
          {dataText}
        </div>
      </>
    );
  };

  if (dataText === "") {
    return navbarHeadings(heading);
  }

  if (heading === "student-dashboard") {
    return myClassroomDashboard();
  }

  return "";
};

export const getMobileNavbarHeading = (heading, dataText = "") => {
  const navbarHeadings = () => {
    return (
      <>
        <div
          className="navbar-heading-title"
          style={{
            fontFamily: "inherit",
            fontWeight: 600,
            lineHeight: "26px",
            textAlign: "left",
            color: "#1D2026",
          }}
        >
          {heading === "my-classrooms" ? "My Classrooms" : heading}
        </div>
      </>
    );
  };

  const myClassroomDashboard = () => {
    return (
      <>
        <div
          className="navbar-heading-title"
          style={{
            fontFamily: "inherit",
            fontWeight: 600,
            lineHeight: "26px",
            textAlign: "left",
            color: "#1D2026",
          }}
        >
          {dataText}
        </div>
      </>
    );
  };

  if (dataText === "") {
    return navbarHeadings(heading);
  }

  if (heading === "student-dashboard") {
    return myClassroomDashboard();
  }

  return "";
};
